import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faAngleUp,
  faSave,
  faTimes,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useRouteMatch,
  withRouter,
  useParams,
} from "react-router-dom";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import "react-tabs/style/react-tabs.css";
import apiUrl from "../../apiUrlConstant";
import { unitTypeConstant, unitStatusConstant } from "../../constants";
import { Redirect } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import Popup from "reactjs-popup";
import { Modal, Button } from "react-bootstrap";
import Select from "react-select";
import { PopupMessage } from "../../utils/utils";
import { clientId } from "../../utils/index";
const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};
class LeaseLandlord extends React.Component {
  validator = [];
  mainFormValidator = [];
  state = {
    submitDisable: false,
    messsagePopup: false,
    popupContent: "",
    vendor_code: "",
    clientGroupName: "",
    clientGroupId: "",
    popupData: {},
    index_val: "",
    popupalertMessage: false,
    popupMessageContent: "",
    isOpen: false,
    delete: false,
    assetId: "",
    tower: "",
    subAssetName: "",
    assetName: "",
    assetNames: [],
    subAssets: [],
    towers: [],
    floors: [],
    unitDetails: [],
    LandlordGroups: [],
    clientGroup: [],
    clientNames: [],
    redirect: false,
    landlords: [],
    landlordCount: 1,
    states: [],
    landlordAssetName: "",
    landlordAssetId: "",
    landlordSubAssetName: "",
    landlordSubAssetId: "",
    landlordTower: "",
    landlordFloor: "",
    landlordUnitNo: "",
    landlordUnitType: "",
    landlordUnitStatus: "",
    units: [],
    leaseId: "",
    costCenter: "",

    notes_1: "",
    totalUsableArea: 0,
    totalGrossLeasableArea: 0,
    leaseCreationDate: "",
    isDisabled: false,
    selectedCompanies: [],
    initialValues: {
      leaseCreationDate: "tghj",
      units: [],
    },
  };

  constructor(props) {
    super(props);
    this.getLandlordUnitNo = this.getLandlordUnitNo.bind(this);
    this.getLandlordUnitType = this.getLandlordUnitType.bind(this);
    this.getLandlordUnitStatus = this.getLandlordUnitStatus.bind(this);
    this.getLandlordownershipPercent =
      this.getLandlordownershipPercent.bind(this);
    this.mainFormValidator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
  }

  openModal = () => this.setState({ isOpen: true });
  closeModal = () => this.setState({ isOpen: false });

  componentDidMount() {
    //fetch(`${apiUrl.apiUrl.url}/client-groups`)
    fetch(`${apiUrl.apiUrl.url}/client-group/fetch-list`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          clientGroup: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/asset/fetch-all-assets`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          assetNames: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
    fetch(`${apiUrl.apiUrl.url}/states/country-states/1`, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          states: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    //fetch(`${apiUrl.apiUrl.url}/landlord-groups`)
    fetch(`${apiUrl.apiUrl.url}/landlord-group/fetch-landlord-list`, {
      headers,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          LandlordGroups: data,
        });
        if (this.props.match.params.id !== undefined) {

          let athis = this;

          axios({
            url: `${apiUrl.apiUrl.url}/create-lease/fetch-landlord-form?id=${this.props.match.params.id}`,
            method: "get",
          }).then(function(res){
            let data = res.data;

            let obj = athis.state.clientGroup.find(
              (o) => o.id == data.clientGroup
            );
            let obj1 = athis.state.assetNames.find(
              (o) => o.id == data.assetId
            );

            athis.setState({
              landlords: data.landlord,
              units: data.units,
              notes_1: data.notes_1,
              leaseId: data.leaseId,
              costCenter: data.costCenter,
              leaseCreationDate: data.leaseCreationDate,
              landlordCount: data.landlord.length,
              clientNames: data.clients,
              subAssets: data.subAssets,
              towers: data.towers,
              floors: data.floors,
              tower: data.tower,
              landlordAssetName: data.assetName,
              landlordSubAssetName: data.subAssetNameValue,
              landlordSubAssetId: data.landlordSubAssetId,
              clientGroupId: data.clientGroup,
              landlordAssetId: data.assetId,
              //vendor_code: data.vendor_code,
              isDisabled: true,
            });
            for (let i = 0; i < data.landlord.length; i++) {
              let obj = athis.state.LandlordGroups.find(
                (o) => o.id == data.landlord[i].companyGroup
              );

              athis.state.landlords[i].companyGroupName = obj.group_name;
            }
            if (data.clientGroup) {
              athis.setState({ clientGroupName: obj.group_name });
            }
            if (data.assetId) {
              athis.setState({
                landlordAssetName: obj1.asset_name,
              });
            }
            for (let i = 0; i < data.landlord.length; i++) {
              let find = data.landlord[i].gstNumber.substring(0, 2);
              var state = athis.state.states.find((x) => x.gst_code == find);
              if (state != undefined) {
                athis.state.landlords[i].gstState = state.id;
                athis.state.landlords[i].gstStateCode = state.gst_code;
              }
              //this.state.landlords[i].vendorCode = data.landlord[i].vendorCode;
            }
            athis.setState({
              initialValues: data,
            });
            athis.setState({});
          });


          // fetch(
          //   `${apiUrl.apiUrl.url}/create-lease/fetch-landlord-form?id=${this.props.match.params.id}`
          // )
          //   .then((response) => {
          //     return response.json();
          //   })
          //   .then((data) => {
          //     let obj = this.state.clientGroup.find(
          //       (o) => o.id == data.clientGroup
          //     );
          //     let obj1 = this.state.assetNames.find(
          //       (o) => o.id == data.assetId
          //     );

          //     this.setState({
          //       landlords: data.landlord,
          //       units: data.units,
          //       notes_1: data.notes_1,
          //       leaseId: data.leaseId,
          //       costCenter: data.costCenter,
          //       leaseCreationDate: data.leaseCreationDate,
          //       landlordCount: data.landlord.length,
          //       clientNames: data.clients,
          //       subAssets: data.subAssets,
          //       towers: data.towers,
          //       floors: data.floors,
          //       tower: data.tower,
          //       landlordAssetName: data.assetName,
          //       landlordSubAssetName: data.subAssetNameValue,
          //       landlordSubAssetId: data.landlordSubAssetId,
          //       clientGroupId: data.clientGroup,
          //       landlordAssetId: data.assetId,
          //       //vendor_code: data.vendor_code,
          //       isDisabled: true,
          //     });
          //     for (let i = 0; i < data.landlord.length; i++) {
          //       let obj = this.state.LandlordGroups.find(
          //         (o) => o.id == data.landlord[i].companyGroup
          //       );

          //       this.state.landlords[i].companyGroupName = obj.group_name;
          //     }
          //     if (data.clientGroup) {
          //       this.setState({ clientGroupName: obj.group_name });
          //     }
          //     if (data.assetId) {
          //       this.setState({
          //         landlordAssetName: obj1.asset_name,
          //       });
          //     }
          //     for (let i = 0; i < data.landlord.length; i++) {
          //       let find = data.landlord[i].gstNumber.substring(0, 2);
          //       var state = this.state.states.find((x) => x.gst_code == find);
          //       if (state != undefined) {
          //         this.state.landlords[i].gstState = state.id;
          //         this.state.landlords[i].gstStateCode = state.gst_code;
          //       }
          //       //this.state.landlords[i].vendorCode = data.landlord[i].vendorCode;
          //     }
          //     this.setState({
          //       initialValues: data,
          //     });
          //     this.setState({});
          //   })
          //   .catch((error) => {
          //     console.log(error);
          //   });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  autoSelectGstState(e, i) {
    let find = e.target.value.substring(0, 2);
    var state = this.state.states.find((x) => x.gst_code == find);
    this.state.landlords[i].gstState = state.id;
    this.state.landlords[i].gstStateCode = state.gst_code;
    this.setState({});
    console.log(state, "Ev");
  }

  getTotalUsableArea() {
    let totalUsableArea = 0;
    for (let i = 0; i < this.state.units.length; i++) {
      totalUsableArea += this.state.units[i].usableArea;
    }
    return totalUsableArea.toFixed(2);
  }
  getTotalGrossleasableArea() {
    let totalGrossleasableArea = 0;
    for (let i = 0; i < this.state.units.length; i++) {
      totalGrossleasableArea += this.state.units[i].grossLeasableArea;
    }
    return totalGrossleasableArea.toFixed(2);
  }

  changeClientGroup(e) {
    this.state.clientGroupName = e.label;
    this.state.clientGroupId = e.value;
    this.setState({});
    console.groupEnd();
    fetch(
      `${apiUrl.apiUrl.url}/client/fetch-group-clients?id=` +
      this.state.clientGroupId,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          clientNames: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  changeAsset = (e, i) => {
    this.state.landlordAssetName = e.label;
    this.state.landlordAssetId = e.value;
    this.setState({});
    console.groupEnd();
    this.setState({});
    fetch(
      `${apiUrl.apiUrl.url}/unit-detail/get-sub-assets?asset_id=` +
      this.state.landlordAssetId,
      {headers}
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          subAssets: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  changeLandlordGroup = (e, i) => {
    this.state.landlords[i].companyGroupName = e.label;
    this.state.landlords[i].companyGroup = e.value;
    this.setState({});
    console.groupEnd();
    this.setState({});
    let groupid = e.value;
    fetch(`${apiUrl.apiUrl.url}/landlord/get-group-companies/?id=` + groupid, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        var _landlords = this.state.landlords;

        _landlords[i].companies = data;
        this.setState({
          landlords: _landlords,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  changeSubAsset = (e) => {
    let subAssetId = e.target.value;
    fetch(`${apiUrl.apiUrl.url}/asset/sub-asset-towers/?id=` + subAssetId, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        // var _landlords = this.state.landlords;

        // _landlords[i].towers = data;
        this.setState({
          towers: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleAddUnit = (e, id, setFieldError) => {
    if (!this.validator[id].allValid()) {
      this.validator[id].getErrorMessages();
      console.log(this.validator[id].getErrorMessages());
      this.validator[id].showMessages();
      this.forceUpdate();
      return false;
    }
    console.log(this.state, "an");
    console.log(this.state.landlords[id], "an");
    let ownershipPercent = this.state.landlords[id].unit.ownershipPercent;
    var thisUnit = {
      unitNo: this.state.landlords[id].unit.unitNo,
      unitId: this.state.landlords[id].unit.unitId,
      unitType: this.state.landlords[id].unit.unitType,
      unitStatus: this.state.landlords[id].unit.unitStatus,
      ownershipPercent: this.state.landlords[id].unit.ownershipPercent,
      landlord: this.state.landlords[id].companyName,
      landlordCompanyName: this.state.landlords[id].companies.find(
        (x) => x.id == this.state.landlords[id].companyName
      ),
      landlordName: this.state.landlords[id].companyGroupName,
      assetName: this.state.landlordAssetName,
      floor: this.state.landlords[id].unit.floor,
      usableArea:
        (this.state.landlords[id].unit.usableArea * ownershipPercent) / 100,
      grossLeasableArea:
        (this.state.landlords[id].unit.grossLeasableArea * ownershipPercent) /
        100,
    };
    var _units = this.state.units;
    console.log(thisUnit, "MMM");
    _units.push(thisUnit);

    this.setState({ units: _units });
    var _landlords = this.state.landlords;
    _landlords[id].unit.tower = "";
    _landlords[id].unit.assetId = "";
    _landlords[id].unit.subAssetName = "";
    _landlords[id].unit.floor = "";
    _landlords[id].unit.unitId = "";
    _landlords[id].unit.unitNo = "";
    _landlords[id].unit.unitType = "";
    _landlords[id].unit.unitStatus = "";
    _landlords[id].unit.usableArea = "";
    _landlords[id].unit.carpetArea = "";
    _landlords[id].unit.grossLeasableArea = "";
    _landlords[id].unit.ownershipPercent = "100";
    this.setState({
      landlords: _landlords,
    });
    console.log(this.state.units);
  };

  resetUnit = (e, id, setFieldError) => {
    var _landlords = this.state.landlords;
    _landlords[id].unit.tower = "";
    _landlords[id].unit.assetId = "";
    _landlords[id].unit.subAssetName = "";
    _landlords[id].unit.floor = "";
    _landlords[id].unit.unitId = "";
    _landlords[id].unit.unitNo = "";
    _landlords[id].unit.unitType = "";
    _landlords[id].unit.unitStatus = "";
    _landlords[id].unit.usableArea = "";
    _landlords[id].unit.carpetArea = "";
    _landlords[id].unit.grossLeasableArea = "";
    _landlords[id].unit.ownershipPercent = "100";
    this.setState({
      landlords: _landlords,
    });
  };

  handleRemoveRow = (index) => {
    this.setState({
      rows: this.state.units.slice(index, -1),
    });
  };

  getLandlordSubAssetName(event) {
    this.setState({
      landlordSubAssetName: event.target.value,
    });
  }

  getLandlordTower(e) {
    this.setState({
      landlordTower: e.target.value,
    });
    let towerId = e.target.value;

    fetch(`${apiUrl.apiUrl.url}/unit-detail/get-floors?tower_id=` + towerId, {
      headers,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          floors: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getLandlordFloor(e, i, id) {
    console.log(e);
    this.state.landlords[i].unit.floor = e.value;
    console.groupEnd();
    this.setState({});
    this.setState({
      landlordFloor: e.value,
    });
    let floorId = e.value;
    var url = `${apiUrl.apiUrl.url}/unit-detail/get-floor-units?tower_id=${this.state.tower}&floor=${floorId}`;
    // var self = this;
    if (this.props.match.params.id !== undefined) {
      url = `${apiUrl.apiUrl.url}/unit-detail/get-floor-units?tower_id=${this.state.tower}&floor=${floorId}&lease_id=${this.props.match.params.id}`;
    }
    fetch(url, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data, "data");
        var _landlords = this.state.landlords;
        _landlords[i].unitDetails = data;
        this.setState({
          landlords: _landlords,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getLandlordUnitNo(event, i) {
    var _landlords = this.state.landlords;
    _landlords[i].unit.unitNo = event.target.value;
    this.setState({
      landlords: _landlords,
    });
  }

  getGSTDetails(company_id, state_id, id) {
    var url = `${apiUrl.apiUrl.url}/create-lease/get-landlord-gst-details?company_id=${company_id}&state_id=${state_id}`;
    fetch(url, {
      headers,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data, "data lease landlord gst");
        this.state.landlords[id].gstNumber = data.gst;
        this.setState({});
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getLandlordUnitStatus(event, i) {
    var _landlords = this.state.landlords;
    _landlords[i].unit.unitStatus = event.target.value;
    this.setState({
      landlords: _landlords,
    });
  }

  getLandlordUnitType(event, i) {
    var _landlords = this.state.landlords;
    _landlords[i].unit.unitType = event.target.value;
    this.setState({
      landlords: _landlords,
    });
  }

  getLandlordownershipPercent(event, i) {
    var _landlords = this.state.landlords;
    _landlords[i].unit.ownershipPercent = event.target.value;
    this.setState({
      landlords: _landlords,
    });
  }
  redirectAfterSave = () => {
    this.setState({ redirect: true, delete: false, popupContent: "" });
  };
  redirectToDelete = () => {
    var _units = this.state.units;
    _units.splice(this.state.index_val, 1);
    this.setState({
      units: _units,
      delete: false,
      index_val: "",
    });
  };

  redirectToClose = () => {
    this.setState({
      delete: false,
      popupalertMessage: false,
      popupMessageContent: "",
    });
  };

  handleDelete = (index) => {
    // Create a copy of the landlords array
    let _landlords = this.state.landlords;

    // Remove the item at the specified index
    _landlords.splice([index - 1], 1);

    // Update the state
    this.setState({
      landlords: _landlords,
      landlordCount: this.state.landlordCount - 1
    });
  }

  landlordTabs(handleChange, setFieldError) {
    var heads = [];
    for (var i = 0; i < this.state.landlordCount; i++) {
      heads.push(<Tab>Landlord {i + 1} {heads.length < 1 ? null : <span onClick={() => this.handleDelete(i)} className="ms-2"><FontAwesomeIcon icon={faTimes} /></span>} </Tab>);
    }
    console.log(heads, "heads")

    var body = [];
    for (var i = 0; i < this.state.landlordCount; i++) {
      if (
        typeof this.state.landlords[i] === "undefined" ||
        this.state.landlords[i] === null
      ) {
        this.state.landlords[i] = {};
        this.state.landlords[i].unit = {};
        this.state.landlords[i].companies = [];
        this.state.landlords[i].subAssets = [];
        this.state.landlords[i].towers = [];
        this.state.landlords[i].floor = [];
        this.state.landlords[i].unitDetails = [];
        this.state.landlords[i].unit.assetId = "";
        this.state.landlords[i].unit.subAssetName = "";
        this.state.landlords[i].unit.tower = "";
        this.state.landlords[i].unit.floor = "";
        this.state.landlords[i].unit.unitType = "";
        this.state.landlords[i].unit.unitStatus = "";
        this.state.landlords[i].unit.usableArea = "";
        this.state.landlords[i].unit.grossLeasableArea = "";
        this.state.landlords[i].unit.carpetArea = "";
        this.state.landlords[i].unit.ownershipPercent = "100";
        this.state.landlords[i].unit.unitNo = "";
        this.state.landlords[i].unit.unitId = "";
        this.state.landlords[i].gstNumber = "";
        this.state.landlords[i].vendorCode = "";
        this.state.landlords[i].gstState = "";
        this.state.landlords[i].gstStateCode = "";
        this.state.landlords[i].invoiceBy = "";
        this.state.landlords[i].companyName = "";
      }
      if (this.validator[i] === undefined) {
        this.validator[i] = new SimpleReactValidator({ autoForceUpdate: this });
      }
      body.push(
        <TabPanel>
          {/* <div className="tabHolder leaseLandlordTab">
            <div className="row tabForm">
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Landlord Group <span className="astrik">*</span>
                    </label>
                    <div className="col-sm-7" style={{ fontSize: "13px" }}>
                      <Select
                        className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                        isSearchable="true"
                        name={"landlord[" + i + "].companyGroup"}
                        value={{
                          label: this.state.landlords[i].companyGroupName,
                          value: this.state.landlords[i].companyGroup,
                        }}
                        onChange={(e, i) => {
                          console.log(i);
                          var id = i.name.split("[")[1].split("]")[0];
                          // console.log(idarray);
                          this.state.landlords[id].companyGroup = e.value;
                          this.changeLandlordGroup(e, id);
                        }}
                        options={this.state.LandlordGroups.map((item) => ({
                          label: item.group_name,
                          value: item.id,
                        }))}
                      />
                      {this.validator[i].message(
                        "Landlord Group",
                        this.state.landlords[i].companyGroup,
                        "required",
                        { className: "text-danger" }
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      {"Landlord Company Name"}{" "}
                      <span className="astrik">*</span>
                    </label>
                    <div className="col-sm-7">
                      <select
                        param={i}
                        value={this.state.landlords[i].companyName}
                        name={"landlord[" + i + "].companyName"}
                        onChange={(e) => {
                          var id = e.target.getAttribute("param");

                          if (
                            this.state.selectedCompanies.indexOf(
                              e.target.value
                            ) > -1
                          ) {
                            // alert("Please Select another company");
                            this.setState({
                              popupalertMessage: true,
                              popupMessageContent:
                                "Please Select another company",
                            });
                          } else {
                            this.state.landlords[id].companyName =
                              e.target.value;
                            this.state.selectedCompanies[id] =
                              this.state.landlords[id].companyName;
                          }
                          handleChange(e);
                          // this.displayUnitDetails(e, )
                        }}
                      >
                        <option value="" label="Select" defaultValue />
                        {this.state.landlords[i].companies.map((obj) => (
                          <option key={"companyName" + obj.id} value={obj.id}>
                            {obj.company_name}
                          </option>
                        ))}
                      </select>
                      <ErrorMessage
                        name={"landlord[" + i + "].companyName"}
                        component="div"
                        className="text-red"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      {"Landlord GST State & GST State Code"}
                      <span className="astrik"></span>
                    </label>
                    <div className="col-sm-4">
                      <select
                        param={i}
                        name={"landlord[" + i + "].gstState"}
                        value={this.state.landlords[i].gstState}
                        onChange={(e) => {
                          var id = e.target.getAttribute("param");
                          this.state.landlords[id].gstState = e.target.value;
                          var state = this.state.states.find(
                            (x) => x.id == e.target.value
                          );
                          var _landlords = this.state.landlords;
                          _landlords[id].gstStateCode = state.gst_code;

                          this.getGSTDetails(
                            _landlords[id]["companyName"],
                            _landlords[id]["gstState"],
                            id
                          );

                          this.setState({
                            landlords: _landlords,
                          });
                          handleChange(e);
                        }}
                      >
                        <option value="" label="Select" defaultValue />
                        {this.state.states.map((obj) => (
                          <option key={"gstState" + obj.id} value={obj.id}>
                            {obj.state_name}
                          </option>
                        ))}
                      </select>
                      <ErrorMessage
                        name={"landlord[" + i + "].gstState"}
                        component="div"
                        className="text-red"
                      />
                    </div>
                    <div className="col-sm-3">
                      <Field
                        type="text"
                        name={"landlord[" + i + "].gstStateCode"}
                        value={this.state.landlords[i].gstStateCode}
                      />
                      <ErrorMessage
                        name={"landlord[" + i + "].gstStateCode"}
                        component="div"
                        className="text-red"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      GST Number <span className="astrik"></span>
                    </label>
                    <div className="col-sm-7">
                      <Field
                        type="text"
                        param={i}
                        name={"landlord[" + i + "].gstNumber"}
                        value={this.state.landlords[i].gstNumber}
                        onChange={(e) => {
                          var id = e.target.getAttribute("param");
                          this.state.landlords[id].gstNumber = e.target.value;
                          handleChange(e);
                        }}
                        onBlur={(e) => {
                          var i = e.target.getAttribute("param");
                          //this.autoSelectGstState(e, i);
                        }}
                      />
                      <ErrorMessage
                        name={"landlord[" + i + "].gstNumber"}
                        component="div"
                        className="text-red"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Invoice By <span className="astrik">*</span>
                    </label>
                    <div className="col-sm-7">
                      <select
                        param={i}
                        name={"landlord[" + i + "].invoiceBy"}
                        value={this.state.landlords[i].invoiceBy}
                        onChange={(e) => {
                          var id = e.target.getAttribute("param");
                          this.state.landlords[id].invoiceBy = e.target.value;
                          handleChange(e);
                        }}
                      >
                        <option value="" label="Select" defaultValue />
                        <option value="yes" label="Yes" />
                        <option value="no" label="No" />
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Vendor Code <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                            <Field
                        type="text"
                        param={i}
                        name={"landlord[" + i + "].vendorCode"}
                        value={this.state.landlords[i].vendorCode}
                        onChange={(e) => {
                          var id = e.target.getAttribute("param");
                          this.state.landlords[id].vendorCode = e.target.value;
                          handleChange(e);
                        }}
                      />


                              
                            </div>
                          </div>
                        </div>
                      </div>
            </div>
          </div> */}

          <div className="unitFormContainerNew">
            <div className="newGridSectionParent px-0">
              <div className="newGridSectionForFormMain">
                <div className="newGridSectionInner">
                  <label>
                    Landlord Group <span className="astrik">*</span>
                  </label>
                  <div className="position-relative">
                    <Select
                      className="basic-single custom-select-style"
                      classNamePrefix="custom-select-style-inner"
                      isSearchable="true"
                      name={"landlord[" + i + "].companyGroup"}
                      value={{
                        label: this.state.landlords[i].companyGroupName,
                        value: this.state.landlords[i].companyGroup,
                      }}
                      onChange={(e, i) => {
                        var id = i.name.split("[")[1].split("]")[0];
                        this.state.landlords[id].companyGroup = e.value;
                        this.changeLandlordGroup(e, id);
                      }}
                      options={this.state.LandlordGroups.map((item) => ({
                        label: item.group_name,
                        value: item.id,
                      }))}
                    />
                    {this.validator[i].message(
                      "Landlord Group",
                      this.state.landlords[i].companyGroup,
                      "required",
                      { className: "text-danger" }
                    )}
                  </div>
                </div>
                <div className="newGridSectionInner">
                  <label>
                    Landlord Company Name <span className="astrik">*</span>
                  </label>
                  <div className="position-relative">
                    <select
                      param={i}
                      value={this.state.landlords[i].companyName}
                      name={"landlord[" + i + "].companyName"}
                      onChange={(e) => {
                        var id = e.target.getAttribute("param");
                        if (this.state.selectedCompanies.indexOf(e.target.value) > -1) {
                          this.setState({
                            popupalertMessage: true,
                            popupMessageContent: "Please Select another company",
                          });
                        } else {
                          this.state.landlords[id].companyName = e.target.value;
                          this.state.selectedCompanies[id] =
                            this.state.landlords[id].companyName;
                        }
                        handleChange(e);
                      }}
                    >
                      <option value="" label="Select" defaultValue />
                      {this.state.landlords[i].companies.map((obj) => (
                        <option key={"companyName" + obj.id} value={obj.id}>
                          {obj.company_name}
                        </option>
                      ))}
                    </select>
                    <ErrorMessage
                      name={"landlord[" + i + "].companyName"}
                      component="div"
                      className="text-red"
                    />
                  </div>
                </div>
                <div className="newGridSectionInner">
                  <label>
                    Landlord GST State & GST State Code
                  </label>
                  <div className="position-relative">
                    <div className="row m-0">
                      <div className="col-6 ps-0">
                        <select
                          param={i}
                          name={"landlord[" + i + "].gstState"}
                          value={this.state.landlords[i].gstState}
                          onChange={(e) => {
                            var id = e.target.getAttribute("param");
                            this.state.landlords[id].gstState = e.target.value;
                            var state = this.state.states.find((x) => x.id == e.target.value);
                            var _landlords = this.state.landlords;
                            _landlords[id].gstStateCode = state.gst_code;
                            this.getGSTDetails(
                              _landlords[id]["companyName"],
                              _landlords[id]["gstState"],
                              id
                            );
                            this.setState({
                              landlords: _landlords,
                            });
                            handleChange(e);
                          }}
                        >
                          <option value="" label="Select" defaultValue />
                          {this.state.states.map((obj) => (
                            <option key={"gstState" + obj.id} value={obj.id}>
                              {obj.state_name}
                            </option>
                          ))}
                        </select>
                        <ErrorMessage
                          name={"landlord[" + i + "].gstState"}
                          component="div"
                          className="text-red"
                        />
                      </div>
                      <div className="col-6 pe-0">
                        <Field
                          type="text"
                          name={"landlord[" + i + "].gstStateCode"}
                          value={this.state.landlords[i].gstStateCode}
                        />
                        <ErrorMessage
                          name={"landlord[" + i + "].gstStateCode"}
                          component="div"
                          className="text-red"
                        />
                      </div>
                    </div>


                  </div>
                </div>
                <div className="newGridSectionInner">
                  <label>
                    GST Number
                  </label>
                  <div className="position-relative">
                    <Field
                      type="text"
                      param={i}
                      name={"landlord[" + i + "].gstNumber"}
                      value={this.state.landlords[i].gstNumber}
                      onChange={(e) => {
                        var id = e.target.getAttribute("param");
                        this.state.landlords[id].gstNumber = e.target.value;
                        handleChange(e);
                      }}
                      onBlur={(e) => {
                        var i = e.target.getAttribute("param");
                      }}
                    />
                    <ErrorMessage
                      name={"landlord[" + i + "].gstNumber"}
                      component="div"
                      className="text-red"
                    />
                  </div>
                </div>
                <div className="newGridSectionInner">
                  <label>
                    Invoice By <span className="astrik">*</span>
                  </label>
                  <div className="position-relative">
                    <select
                      param={i}
                      name={"landlord[" + i + "].invoiceBy"}
                      value={this.state.landlords[i].invoiceBy}
                      onChange={(e) => {
                        var id = e.target.getAttribute("param");
                        this.state.landlords[id].invoiceBy = e.target.value;
                        handleChange(e);
                      }}
                    >
                      <option value="" label="Select" defaultValue />
                      <option value="yes" label="Yes" />
                      <option value="no" label="No" />
                    </select>
                  </div>
                </div>

                {this.state.landlords[i].companyName !== "" && (
                  <>
                    <div className="gridColOneByThree textWithHrTag textWithHrTagWithFlex my-3">
                      <hr className="m-0 mt-1" />
                      <h4 className="clrBlue">Unit Details</h4>
                    </div>

                    <div className="newGridSectionInner">
                      <label>
                        Floor <span className="astrik">*</span>
                      </label>
                      <div className="position-relative">
                        <Select
                          className="basic-single custom-select-style"
                          classNamePrefix="custom-select-style-inner"
                          isSearchable="true"
                          name={"landlord[" + i + "].unit[" + i + "].floor"}
                          value={{
                            label: this.state.landlords[i].unit.floor,
                            value: this.state.landlords[i].unit.floor,
                          }}
                          onChange={(e, i) => {
                            var id = i.name.split("[")[1].split("]")[0];
                            let towerId = this.state.landlords[id].unit.tower;
                            this.getLandlordFloor(e, id, towerId);
                          }}
                          options={this.state.floors.map((item) => ({
                            label: item.floor,
                            value: item.floor,
                          }))}
                        />
                        {this.validator[i].message(
                          "Floor",
                          this.state.landlords[i].unit.floor,
                          "required",
                          { className: "text-danger" }
                        )}
                      </div>
                    </div>

                    <div className="newGridSectionInner">
                      <label>
                        Unit No <span className="astrik">*</span>
                      </label>
                      <div className="position-relative">
                        <select
                          param={i}
                          value={this.state.landlords[i].unit.unitId}
                          name={"landlord[" + i + "].unit[" + i + "].unitId"}
                          onChange={(e) => {
                            var id = e.target.getAttribute("param");
                            let selectedUnits = this.state.units;
                            var doesExist = selectedUnits.some(
                              (el) =>
                                el.unitId == e.target.value &&
                                this.state.landlords[id].companyName == el.landlord
                            );
                            if (doesExist) {
                              this.setState({
                                popupalertMessage: true,
                                popupMessageContent: "Please select different unit",
                              });
                              return false;
                            } else {
                              var unit = this.state.landlords[
                                id
                              ].unitDetails.find((x) => x.id == e.target.value);
                              var _landlords = this.state.landlords;
                              _landlords[id].unit.unitId = e.target.value;

                              if (e.target.value !== undefined) {
                                _landlords[id].unit.carpetArea = unit.carpet_area;
                                _landlords[id].unit.usableArea = unit.usable_area;
                                _landlords[id].unit.grossLeasableArea = unit.gross_leasable_area;
                                _landlords[id].unit.unitNo = unit.unit_no;
                                _landlords[id].unit.unitType = unit.unit_type;
                                _landlords[id].unit.unitStatus = unit.unit_status;
                                this.setState({
                                  landlords: _landlords,
                                });
                              }
                            }
                            handleChange(e);
                          }}
                        >
                          <option value="" label="Select" defaultValue />
                          {this.state.landlords[i].unitDetails.map((obj) => (
                            <option key={"unit" + obj.id} value={obj.id}>
                              {obj.unit_no}
                            </option>
                          ))}
                        </select>
                        {this.validator[i].message(
                          "Unit No",
                          this.state.landlords[i].unit.unitId,
                          "required",
                          { className: "text-danger" }
                        )}
                      </div>
                    </div>
                    <div className="newGridSectionInner">
                      <label>
                        Unit Type <span className="astrik">*</span>
                      </label>
                      <div className="position-relative">
                        <Field
                          param={i}
                          value={this.state.landlords[i].unit.unitType}
                          type="text"
                          name={"landlord[" + i + "].unit[" + i + "].unitType"}
                          onChange={(e) => {
                            var id = e.target.getAttribute("param");
                            this.getLandlordUnitType(e, id);
                            handleChange(e);
                          }}
                        />
                        {this.validator[i].message(
                          "Unit Type",
                          this.state.landlords[i].unit.unitType,
                          "required",
                          { className: "text-danger" }
                        )}
                      </div>
                    </div>
                    <div className="newGridSectionInner">
                      <label>
                        Unit Status <span className="astrik">*</span>
                      </label>
                      <div className="position-relative">
                        <Field
                          param={i}
                          value={this.state.landlords[i].unit.unitStatus}
                          type="text"
                          name={"landlord[" + i + "].unit[" + i + "].unitStatus"}
                          onChange={(e) => {
                            var id = e.target.getAttribute("param");
                            this.getLandlordUnitStatus(e, id);
                            handleChange(e);
                          }}
                        />
                      </div>
                    </div>
                    <div className="newGridSectionInner">
                      <label>
                        Ownership Percent % <span className="astrik">*</span>
                      </label>
                      <div className="position-relative">
                        <Field
                          min="1"
                          max="100"
                          param={i}
                          value={this.state.landlords[i].unit.ownershipPercent}
                          type="number"
                          name={"landlord[" + i + "].unit[" + i + "].ownershipPercent"}
                          onChange={(e) => {
                            var id = e.target.getAttribute("param");
                            this.getLandlordownershipPercent(e, id);
                            handleChange(e);
                          }}
                        />
                        {this.validator[i].message(
                          "Ownership Percent",
                          this.state.landlords[i].unit.ownershipPercent,
                          "required",
                          { className: "text-danger" }
                        )}
                      </div>
                    </div>
                    <div className="newGridSectionInner">
                      <label>
                        Carpet Area (sq.ft) <span className="astrik">*</span>
                      </label>
                      <div className="position-relative">
                        <Field
                          param={i}
                          value={this.state.landlords[i].unit.carpetArea}
                          type="text"
                          name={"landlord[" + i + "].unit[" + i + "].carpetArea"}
                          onChange={(e) => {
                            var id = e.target.getAttribute("param");
                            handleChange(e);
                          }}
                        />
                      </div>
                    </div>
                    <div className="newGridSectionInner">
                      <label>
                        Usable Area (sq.ft) <span className="astrik">*</span>
                      </label>
                      <div className="position-relative">
                        <Field
                          param={i}
                          value={this.state.landlords[i].unit.usableArea}
                          type="text"
                          name={"landlord[" + i + "].unit[" + i + "].usableArea"}
                          onChange={(e) => {
                            var id = e.target.getAttribute("param");
                            this.getLandlordUnitStatus(e, id);
                            handleChange(e);
                          }}
                        />
                      </div>
                    </div>
                    <div className="newGridSectionInner">
                      <label>
                        Gross Leasable Area (sq.ft) <span className="astrik">*</span>
                      </label>
                      <div className="position-relative">
                        <Field
                          param={i}
                          value={this.state.landlords[i].unit.grossLeasableArea}
                          type="text"
                          name={"landlord[" + i + "].unit[" + i + "].grossLeasableArea"}
                          onChange={(e) => {
                            var id = e.target.getAttribute("param");
                            this.getLandlordUnitStatus(e, id);
                            handleChange(e);
                          }}
                        />
                      </div>
                    </div>
                    <div className="gridColOneByThree">
                      <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                        <button
                          param={i}
                          type="button"
                          onClick={(e) => {
                            var a = e.target.getAttribute("param");
                            this.handleAddUnit(e, a, setFieldError);
                          }}
                          className="add_button"
                        >
                          {/* DELETE */}
                          Add Unit
                        </button>
                        <button
                          param={i}
                          type="button"
                          onClick={(e) => {
                            var a = e.target.getAttribute("param");
                            this.resetUnit(e, a, setFieldError);
                          }}
                          className="reset_button"
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>

          {/* {this.state.landlords[i].companyName !== "" && (
            <div className="tabHolder1">
              <div className="row tabForm">
                <div className="col-md-12">
                  <h4 className="mb-4">Unit Details</h4>
                </div>
                <div className="col-lg-6">
                  <div className="inputContainer col-lg-12 col-md-12">
                    <div className="row mb-3">
                      <label className="col-sm-4 col-form-label">
                        Floor <span className="astrik">*</span>
                      </label>
                      <div className="col-sm-7" style={{ fontSize: "13px" }}>
                        <Select
                      className="basic-single custom-select-style"
                      classNamePrefix="custom-select-style-inner"
                          isSearchable="true"
                          name={"landlord[" + i + "].unit[" + i + "].floor"}
                          value={{
                            label: this.state.landlords[i].unit.floor,
                            value: this.state.landlords[i].unit.floor,
                          }}
                          onChange={(e, i) => {
                            var id = i.name.split("[")[1].split("]")[0];
                            let towerId = this.state.landlords[id].unit.tower;
                            this.getLandlordFloor(e, id, towerId);
                            // this.state.landlords[id].unit.floor = e.value;
                          }}
                          options={this.state.floors.map((item) => ({
                            label: item.floor,
                            value: item.floor,
                          }))}
                        />
                        {this.validator[i].message(
                          "Floor",
                          this.state.landlords[i].unit.floor,
                          "required",
                          { className: "text-danger" }
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row tabForm">
                <div className="col-lg-6">
                  <div className="inputContainer col-lg-12 col-md-12">
                    <div className="row mb-3">
                      <label className="col-sm-4 col-form-label">
                        Unit No <span className="astrik">*</span>
                      </label>
                      <div className="col-sm-7">
                        <select
                          param={i}
                          value={this.state.landlords[i].unit.unitId}
                          name={"landlord[" + i + "].unit[" + i + "].unitId"}
                          onChange={(e) => {
                            var id = e.target.getAttribute("param");
                            let selectedUnits = this.state.units;
                            var doesExist = selectedUnits.some(
                              (el) =>
                                el.unitId == e.target.value &&
                                this.state.landlords[id].companyName ==
                                el.landlord
                            );
                            if (doesExist) {
                              // alert("Please select different unit");
                              this.setState({
                                popupalertMessage: true,
                                popupMessageContent:
                                  "Please select different unit",
                              });
                              return false;
                            } else {
                              var unit = this.state.landlords[
                                id
                              ].unitDetails.find((x) => x.id == e.target.value);
                              var _landlords = this.state.landlords;
                              _landlords[id].unit.unitId = e.target.value;

                              if (e.target.value !== undefined) {
                                _landlords[id].unit.carpetArea =
                                  unit.carpet_area;
                                _landlords[id].unit.usableArea =
                                  unit.usable_area;
                                _landlords[id].unit.grossLeasableArea =
                                  unit.gross_leasable_area;
                                _landlords[id].unit.unitNo = unit.unit_no;
                                _landlords[id].unit.unitType = unit.unit_type;

                                _landlords[id].unit.unitStatus =
                                  unit.unit_status;
                                this.setState({
                                  landlords: _landlords,
                                });
                              }
                            }
                            handleChange(e);
                          }}
                        >
                          <option value="" label="Select" defaultValue />
                          {this.state.landlords[i].unitDetails.map((obj) => (
                            <option key={"unit" + obj.id} value={obj.id}>
                              {obj.unit_no}
                            </option>
                          ))}
                        </select>
                        {this.validator[i].message(
                          "Unit No",
                          this.state.landlords[i].unit.unitId,
                          "required",
                          { className: "text-danger" }
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="inputContainer col-lg-12 col-md-12">
                    <div className="row mb-3">
                      <label className="col-sm-4 col-form-label">
                        Unit Type <span className="astrik">*</span>
                      </label>
                      <div className="col-sm-7">
                        <Field
                          param={i}
                          value={this.state.landlords[i].unit.unitType}
                          type="text"
                          name={"landlord[" + i + "].unit[" + i + "].unitType"}
                          onChange={(e) => {
                            var id = e.target.getAttribute("param");
                            this.getLandlordUnitType(e, id);
                            handleChange(e);
                          }}
                        />
                        {this.validator[i].message(
                          "Unit Type",
                          this.state.landlords[i].unit.unitType,
                          "required",
                          { className: "text-danger" }
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="inputContainer col-lg-12 col-md-12">
                    <div className="row mb-3">
                      <label className="col-sm-4 col-form-label">
                        Unit Status <span className="astrik">*</span>
                      </label>
                      <div className="col-sm-7">
                        <Field
                          param={i}
                          value={this.state.landlords[i].unit.unitStatus}
                          type="text"
                          name={
                            "landlord[" + i + "].unit[" + i + "].unitStatus"
                          }
                          onChange={(e) => {
                            var id = e.target.getAttribute("param");
                            this.getLandlordUnitStatus(e, id);
                            handleChange(e);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="inputContainer col-lg-12 col-md-12">
                    <div className="row mb-3">
                      <label className="col-sm-4 col-form-label">
                        Ownership Percent % <span className="astrik">*</span>
                      </label>
                      <div className="col-sm-7">
                        <Field
                          min="1"
                          max="100"
                          param={i}
                          value={this.state.landlords[i].unit.ownershipPercent}
                          type="number"
                          name={
                            "landlord[" +
                            i +
                            "].unit[" +
                            i +
                            "].ownershipPercent"
                          }
                          onChange={(e) => {
                            var id = e.target.getAttribute("param");
                            this.getLandlordownershipPercent(e, id);
                            handleChange(e);
                          }}
                        />
                        {this.validator[i].message(
                          "Ownership Percent",
                          this.state.landlords[i].unit.ownershipPercent,
                          "required",
                          { className: "text-danger" }
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="inputContainer col-lg-12 col-md-12">
                    <div className="row mb-3">
                      <label className="col-sm-4 col-form-label">
                        Carpet Area (sq.ft) <span className="astrik">*</span>
                      </label>
                      <div className="col-sm-7">
                        <Field
                          param={i}
                          value={this.state.landlords[i].unit.carpetArea}
                          type="text"
                          name={
                            "landlord[" + i + "].unit[" + i + "].carpetArea"
                          }
                          onChange={(e) => {
                            var id = e.target.getAttribute("param");
                            // this.getLandlordUnitStatus(e, id);
                            handleChange(e);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="inputContainer col-lg-12 col-md-12">
                    <div className="row mb-3">
                      <label className="col-sm-4 col-form-label">
                        Usable Area (sq.ft) <span className="astrik">*</span>
                      </label>
                      <div className="col-sm-7">
                        <Field
                          param={i}
                          value={this.state.landlords[i].unit.usableArea}
                          type="text"
                          name={
                            "landlord[" + i + "].unit[" + i + "].usableArea"
                          }
                          onChange={(e) => {
                            var id = e.target.getAttribute("param");
                            this.getLandlordUnitStatus(e, id);
                            handleChange(e);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="inputContainer col-lg-12 col-md-12">
                    <div className="row mb-3">
                      <label className="col-sm-4 col-form-label">
                        Gross Leasable Area (sq.ft){" "}
                        <span className="astrik">*</span>
                      </label>
                      <div className="col-sm-7">
                        <Field
                          param={i}
                          value={this.state.landlords[i].unit.grossLeasableArea}
                          type="text"
                          name={
                            "landlord[" +
                            i +
                            "].unit[" +
                            i +
                            "].grossLeasableArea"
                          }
                          onChange={(e) => {
                            var id = e.target.getAttribute("param");
                            this.getLandlordUnitStatus(e, id);
                            handleChange(e);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="rowb tnRow">
                <div className="col-lg-6 offset-lg-6">
                  <div className="btnContainer">
                    <div>
                      <button
                        param={i}
                        type="button"
                        onClick={(e) => {
                          var a = e.target.getAttribute("param");
                          this.handleAddUnit(e, a, setFieldError);
                        }}
                      >
                        Add Unit
                      </button>
                      <button
                        param={i}
                        type="button"
                        onClick={(e) => {
                          var a = e.target.getAttribute("param");
                          this.resetUnit(e, a, setFieldError);
                        }}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )} */}
        </TabPanel>
      );
    }

    return (
      <div>
        <Tabs key="landlordTabs">
          <div className="row m-0 mb-3 align-items-center border-bottom-class">
            <div className="col-10 ps-0">
              <TabList>{heads}</TabList>
            </div>
            <div className="button_group col-2 text-end p-0">
              <button className="update_button" type="button"
                onClick={(e) => {
                  // let _landlords = this.state.landlords;
                  // _landlords.splice([i - 1], 1);
                  this.setState({
                    // landlords: _landlords,
                    landlordCount: this.state.landlordCount + 1,
                  });
                }}>
                <FontAwesomeIcon icon={faPlus} /> Add Landlord
              </button>
            </div>
          </div>
          <div>{body}</div>
        </Tabs>
      </div>
    );
  }

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return (
        <Redirect
          push
          to={"/createlease/lease-occupier/" + this.state.leaseId}
        />
      );
    }
    return (
      <div className="parentContainer createLease">
        <div className="absoluteItemForTopBar">
          <div className="new_breadcrumbs_design">
            <ul className="d-flex align-items-center gap-3 p-0 m-0">
              <li>Create Lease</li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>Parties, Unit & Brand Details</li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <a href="#">Landlord & Unit Details</a>
              </li>
            </ul>
          </div>
        </div>

        <Formik
          initialValues={this.state.initialValues}
          enableReinitialize
          onSubmit={(values, actions) => {
            var unitsOwnership = {};
            var totalPercentage = 0;
            for (let i = 0; i < this.state.units.length; i++) {
              if (unitsOwnership[this.state.units[i].unitId] == undefined) {
                unitsOwnership[this.state.units[i].unitId] = Number(
                  this.state.units[i].ownershipPercent
                );
                totalPercentage += this.state.units[i].ownershipPercent;
              } else {
                unitsOwnership[this.state.units[i].unitId] += Number(
                  this.state.units[i].ownershipPercent
                );
                totalPercentage += this.state.units[i].ownershipPercent;
              }
            }

            // for (var key in unitsOwnership) {
            //   if (unitsOwnership[key] < 100) {
            //     // alert("Unit Ownership should be 100 %");
            //     this.setState({
            //       popupalertMessage: true,
            //       popupMessageContent: "Unit Ownership should be 100 %",
            //     });
            //     return false;
            //   }
            // }
            if (totalPercentage < 100) {
              this.setState({
                popupalertMessage: true,
                popupMessageContent: "Unit Ownership should be 100 %",
              });
              return false;
            }

            values.clientGroup = this.state.clientGroupId;
            values.assetId = this.state.landlordAssetId;

            if (!this.mainFormValidator.allValid()) {
              this.mainFormValidator.getErrorMessages();
              this.mainFormValidator.showMessages();
              this.forceUpdate();
              return false;
            }
            values.units = this.state.units;
            var url = `${apiUrl.apiUrl.url}/create-lease/create-lease-landlord`;
            var self = this;
            if (this.props.match.params.id !== undefined) {
              url = `${apiUrl.apiUrl.url}/create-lease/update-lease-landlord?lease_id=${this.props.match.params.id}`;
            }

            this.setState({ submitDisable: true });
            console.log(values);
            axios({
              method: "post",
              url: url,
              data: values,
            }).then(function (response) {
              if (!response.data.success) {
                self.setState({ submitDisable: false });
                actions.setSubmitting(false);
                actions.setErrors(response.data);
                self.setState({ submitDisable: false });
              } else {
                //alert("Data Saved Successfully");
                self.setState({
                  submitDisable: false,
                  messsagePopup: true,
                  leaseId: response.data.id,

                  popupContent: "Data Saved Successfully!",
                  //submitDisable: true
                });
              }
            });
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,

            actions,
            setFieldError,
          }) => (
            <>
              <div className="unitFormContainerNew">
                <Form autoComplete="off"  className="customTabs"  >
                  <div className="newGridSectionParent">
                    <div className="newGridSectionForFormMain">
                      {this.props.match.params.id && (
                        <>
                          <div className="newGridSectionInner">
                            <label>
                              Lease Id <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Field
                                type="text"
                                name="leaseId"
                                value={this.state.leaseId}
                                readOnly="true"
                              />
                              <ErrorMessage
                                name="leaseId"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                          <div className="newGridSectionInner">
                            <label>
                              Lease Creation Date <span className="astrik"></span>
                            </label>
                            <div className="position-relative">
                              <Field
                                type="date"
                                name="leaseCreationDate"
                                value={this.state.leaseCreationDate}
                                readOnly="true"
                              />
                              <ErrorMessage
                                name="leaseCreationDate"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </>
                      )}

                      {(clientId() === "" || clientId() === null) && (
                        <>
                          <div className="newGridSectionInner">
                            <label>
                              Client Group <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Select
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                                isSearchable="true"
                                isDisabled={this.state.isDisabled}
                                name="clientGroup"
                                value={{
                                  label: this.state.clientGroupName,
                                  value: this.state.clientGroupId,
                                }}
                                onChange={(e) => {
                                  this.changeClientGroup(e);
                                }}
                                options={this.state.clientGroup.map((item) => ({
                                  label: item.group_name,
                                  value: item.id,
                                }))}
                              />
                              {this.mainFormValidator.message(
                                "Client Group",
                                values.clientGroup,
                                "required",
                                { className: "text-danger" }
                              )}
                            </div>
                          </div>
                          <div className="newGridSectionInner">
                            <label>
                              Client Name <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Field
                                as="select"
                                name={"clientName"}
                                onChange={(e) => {
                                  handleChange(e);
                                }}
                                disabled={this.state.isDisabled}
                              >
                                <option value="" label="Select" defaultValue />
                                {this.state.clientNames.map((obj) => (
                                  <option key={"clientNames" + obj.id} value={obj.id}>
                                    {obj.client_name}
                                  </option>
                                ))}
                              </Field>
                              {this.mainFormValidator.message(
                                "Client Name",
                                values.clientName,
                                "required",
                                { className: "text-danger" }
                              )}
                            </div>
                          </div>
                        </>
                      )}

                      <div className="newGridSectionInner">
                        <label>
                          Landlord Asset Name <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            isSearchable="true"
                            isDisabled={this.state.isDisabled}
                            name="assetId"
                            value={{
                              label: this.state.landlordAssetName,
                              value: this.state.landlordAssetId,
                            }}
                            onChange={(e) => {
                              this.changeAsset(e);
                            }}
                            options={this.state.assetNames.map((item) => ({
                              label: item.asset_name,
                              value: item.id,
                            }))}
                          />
                          {this.mainFormValidator.message(
                            "Landlord Asset Name",
                            values.assetId,
                            "required",
                            { className: "text-danger" }
                          )}
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          Landlord Sub Asset Name <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field
                            as="select"
                            name={"subAssetName"}
                            disabled={this.state.isDisabled}
                            onChange={(e) => {
                              this.changeSubAsset(e);
                              handleChange(e);
                              this.getLandlordSubAssetName(e);
                            }}
                          >
                            <option value="" label="Select" defaultValue />
                            {this.state.subAssets.map((obj) => (
                              <option key={"subAssetName" + obj.id} value={obj.id}>
                                {obj.sub_asset_name}
                              </option>
                            ))}
                          </Field>
                          {this.mainFormValidator.message(
                            "Landlord Sub Asset Name",
                            values.subAssetName,
                            "required",
                            { className: "text-danger" }
                          )}
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          Tower <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field
                            as="select"
                            name={"tower"}
                            disabled={this.state.isDisabled}
                            onChange={(e) => {
                              this.state.tower = e.target.value;
                              handleChange(e);
                              this.getLandlordTower(e);
                            }}
                          >
                            <option value="" label="Select" defaultValue />
                            {this.state.towers.map((obj) => (
                              <option key={"tower" + obj.id} value={obj.id}>
                                {obj.tower_name}
                              </option>
                            ))}
                          </Field>
                          {this.mainFormValidator.message(
                            "Tower",
                            values.tower,
                            "required",
                            { className: "text-danger" }
                          )}
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>No. of Landlords</label>
                        <div className="position-relative">
                          <Field
                            className="disable"
                            type="text"
                            value={this.state.landlordCount}
                            name="totalLandlord"
                            onChange={(e) => {
                              if (Number(e.target.value) < this.state.landlordCount) {
                                let _landlords = this.state.landlords;
                                _landlords.splice(
                                  _landlords.length - 1,
                                  this.state.landlordCount - Number(e.target.value)
                                );
                                this.setState({ landlords: _landlords });
                              }

                              if (!isNaN(e.target.value)) {
                                this.setState({
                                  landlordCount: e.target.value,
                                });
                              }
                            }}
                          />
                          <ErrorMessage
                            name="totalLandlord"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>
                      <div className="gridColOneByThree">
                        {this.landlordTabs(handleChange, setFieldError)}
                      </div>
                      <div className="gridColOneByThree">
                        <table className="table tableSimple w-100">
                          <thead>
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col">Landlord</th>
                              <th scope="col">Asset Name</th>
                              <th scope="col">Floor</th>
                              <th scope="col">Unit No</th>
                              <th scope="col">Usable Area (sq.ft)</th>
                              <th scope="col">Gross Leasable Area (sq.ft)</th>
                              <th scope="col">Percentage (%)</th>
                              <th scope="col">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.units.map(function (name, index) {
                              return (
                                <tr key={"unitsTable" + index} rowSpan={index}>
                                  <td>{index + 1}</td>
                                  <td>
                                    {name.landlordCompanyName != undefined ||
                                      name.landlordCompanyName != null
                                      ? name.landlordCompanyName.company_name
                                      : name.landlordName}
                                  </td>
                                  <td>{name.assetName}</td>
                                  <td>{name.floor}</td>
                                  <td>
                                    <a
                                      className="popupLink"
                                      onClick={(e) => {
                                        this.state.popupData = name;
                                        this.openModal();
                                      }}
                                    >
                                      {name.unitNo}
                                    </a>
                                  </td>
                                  <td>{name.usableArea}</td>
                                  <td>{name.grossLeasableArea}</td>
                                  <td>{name.ownershipPercent}</td>
                                  <td>
                                    <button
                                      type="button"
                                      className="actionDelete rentalDeleteButton"
                                      onClick={(e) => {
                                        this.setState({
                                          delete: true,
                                          index_val: index,
                                        });
                                      }}
                                    >
                                      <FontAwesomeIcon icon={faTimes} />
                                    </button>
                                  </td>
                                </tr>
                              );
                            }, this)}
                          </tbody>
                          <tfoot>
                            <tr>
                              <td></td>
                              <td colSpan="4">
                                <h6 className="p-0 m-0">Total Lease Area (sq.ft)</h6>
                              </td>
                              <td>{this.getTotalUsableArea()}</td>
                              <td>{this.getTotalGrossleasableArea()}</td>
                              <td></td>
                              <td></td>
                            </tr>
                          </tfoot>
                        </table>
                        <label>Notes/Remarks</label>
                        <Field
                          as="textarea"
                          className="notes"
                          name="notes_1"
                          value={this.state.notes_1}
                          onChange={(e) => {
                            this.state.notes_1 = e.target.value;
                            handleChange(e);
                          }}
                        />
                      </div>
                    </div>
                    <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                      <button
                        type="submit"
                        className="add_button"
                        disabled={this.state.submitDisable}
                      >
                        Save & Next
                      </button>
                      <button type="reset" className="reset_button">
                        <Link to="/createlease">
                          Cancel
                        </Link>
                      </button>
                    </div>
                  </div>
                </Form>
              </div>

            </>
          )}
        </Formik>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <Modal
                show={this.state.isOpen}
                onHide={this.closeModal}
                size="lg"
                className="documentModal"
              >
                <Modal.Header closeButton>
                  <Modal.Title>
                    <div className="container modalBreadCrumbs">
                      <div className="row">
                        <div className="col-lg-12">
                          <ul>
                            <li>Unit Details</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>{this.unitPopup(this.state.popupData)}</Modal.Body>
              </Modal>
            </div>
          </div>
        </div>
        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
        <Popup open={this.state.delete} position="top center">
          {(close) => (
            <div>
              "Are you sure you want to delete the item?"
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
              <div>
                <button type="button" onClick={this.redirectToDelete}>
                  Yes
                </button>
              </div>
            </div>
          )}
        </Popup>
        <Popup open={this.state.popupalertMessage} position="top center">
          {(close) => (
            <div>
              {this.state.popupMessageContent}
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
            </div>
          )}
        </Popup>
      </div>
    );
  }
  unitPopup(unit) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Asset Name <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {unit.assetName}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="row mb-3">
              <label className="col-sm-4 col-form-label">
                Floor <span className="astrik">*</span>
              </label>
              <label className="col-sm-7 col-form-label">{unit.floor}</label>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Unit No <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{unit.unitNo}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Unit Type <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {unit.unitType}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Unit Status <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {unit.unitStatus}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Carpet Area (sq.ft) <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {unit.carpetArea}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Usable Area (sq.ft) <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {unit.usableArea}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Gross Leasable Area (sq.ft) <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {unit.grossLeasableArea}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Ownership Percent % <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {unit.ownershipPercent}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(LeaseLandlord);
